import { type ReactNode, useMemo } from 'react'
import { type CustomFieldValue } from '@terros/common'
import { MultiSelect } from '@mantine/core'
import { toCustomFieldMultiSelectOptions, toCustomFieldMultiSelectValue } from '@front/model'
import { type InputFieldProps } from './types'
import { toMultiSelectCustomFieldValue } from './inputValue'

type Props = InputFieldProps & {
  options: string[]
  value: CustomFieldValue | undefined
  onChange: (value: CustomFieldValue) => void
  disabled?: boolean
}

export const MultipleChoiceMultiSelect = ({ options, value, onChange, ...inputProps }: Props): ReactNode => {
  const values = useMemo(() => toCustomFieldMultiSelectValue(value), [value])
  const data = useMemo(() => toCustomFieldMultiSelectOptions(options, values), [options, values])

  return (
    <MultiSelect
      {...inputProps}
      clearable
      searchable
      data={data}
      value={values}
      onChange={(next) => onChange(toMultiSelectCustomFieldValue(next))}
    />
  )
}
